import { app } from '../../bootstrap/core';
import {
  SecuritiesService,
  BankSearchService
} from './dataSource';

app.service('securitiesService', SecuritiesService);
app.service('bankSourceService', BankSearchService);



// WEBPACK FOOTER //
// ./src/app/common/data/data.js